<template>
  <nav class="navbar navbar-expand-sm navbar-dark bg-dark" v-show="isLogged && isAdmin">
    <router-link to="/calculadora" class="navbar-brand">IMC</router-link>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">

        <router-link
          v-show="isLogged && isAdmin"
          v-for="link in links"
          v-if="showOnNav(link)"
          tag="li" :to="link.path" class="nav-item"
          :key="link.path"
        >
          <a class="nav-link">{{link.meta.humanName}} <span v-if="qtdSol" class="badge badge-danger">{{link.path === '/solicitacoes' ? qtdSol : ''}}</span></a>
        </router-link>

      </ul>
      <ul class="navbar-nav my-2 my-md-0 mr-md-3 ">
        <li class="nav-item">
          <router-link  v-show="isLogged" to="/logout" class="nav-link">sair</router-link>
          <router-link  v-show="!isLogged" to="/login" class="nav-link">login</router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import store from "@/store";

export default {
  name: 'app-nav',
  data() {
    return {
      qtdSol: 0,
      links: [],
    }
  },
  methods: {
    logout() {
      this.$router.go('/logout')
    },
    showOnNav(link) {
      return link.meta && link.meta.showOnNav
    }
  },
  computed: {
    isLogged() {
      return store.state.isLogged
    },
    isAdmin() {
      return store.state.isAdmin
    }
  },
  async beforeMount() {
    this.links = this.$router.options.routes;
    const qtdSol = await this.$http.get('/v1/alimento/solicitacoesqtd');
    this.qtdSol = qtdSol.data.data;
    console.log(qtdSol.data.data)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nav.vue